module.exports = __webpack_public_path__ + "static/media/security-questions.0ff47dd0.svg";